import http from '../core/http-common'
import { IFavoriteCampusServices, IFavoriteLocations } from 'types/FavoritesType'

class FavoritesService {
  /* Locations (Firm |Shared ) */

  getFavoriteLocations(isShared: boolean) {
    return http.get<IFavoriteLocations[]>(`FavoriteLocationFloor/GetFavoriteFloors?isShared=${isShared}`)
  }

  saveFavoriteLocation(floorId: number) {
    return http.get(`FavoriteLocationFloor/Save?floorId=${floorId}`)
  }

  removeFavoriteLocation(floorId: number) {
    return http.get(`FavoriteLocationFloor/Delete?floorId=${floorId}`)
  }

  /* Campus Services */
  getFavoriteCampusServicesList() {
    return http.get<IFavoriteCampusServices[]>(`FavoriteCampusServices/GetFavoriteCampusServices`)
  }
}

export default new FavoritesService()
